export enum RiskAssessmentActionTypes {
  //all RiskAssessment
  GetRiskAssessment = 'RiskAssessment/all',
  GetRiskAssessmentSuccess = 'RiskAssessmentSuccess/all',
  GetRiskAssessmentFail = 'RiskAssessmentFail/all',
  //GetOneRiskAssessment
  GetOneRiskAssessment = 'RiskAssessment/one',
  GetOneRiskAssessmentSuccess = 'RiskAssessmentSuccess/one',
  GetOneRiskAssessmentFail = 'RiskAssessmentFail/one',
  //create RiskAssessment
  CreateRiskAssessment = 'RiskAssessment/create',
  CreateRiskAssessmentSuccess = 'RiskAssessmentSuccess/create',
  CreateRiskAssessmentFail = 'RiskAssessmentFail/create',
  //delete
  DeleteRiskAssessment = 'RiskAssessment/delete',
  DeleteRiskAssessmentSuccess = 'RiskAssessmentSuccess/delete',
  DeleteRiskAssessmentFail = 'RiskAssessmentFail/delete',
  //all RiskAssessment component
  GetRiskAssessmentComponent = 'RiskAssessmentComponent/all',
  GetRiskAssessmentComponentSuccess = 'RiskAssessmentComponentSuccess/all',
  GetRiskAssessmentComponentFail = 'RiskAssessmentComponentFail/all',

  CreateRiskAssessmentComponent = 'RiskAssessmentComponent/create',
  CreateRiskAssessmentComponentSuccess = 'RiskAssessmentComponentSuccess/create',
  CreateRiskAssessmentComponentFail = 'RiskAssessmentComponentFail/create',
  //chanta arzyabi
  CreateRiskComponents = 'RiskComponents/create',
  CreateRiskComponentsSuccess = 'RiskComponentsSuccess/create',
  CreateRiskComponentsFail = 'RiskComponentsFail/create',
}
